const TeamMemberRoleConstants = {
  MAINTAINER: "MAINTAINER",
  MEMBER: "MEMBER",
} as const;

export default TeamMemberRoleConstants;
